/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { EnquiryCardContainer, Content, Title, Text } from './styles'

const EnquiryCard = ({ field, value, person }) => {

  if (person.idQuestion === 427 || person.idQuestion === 480) {
    value = person.answerOptions.find(question => question.idAnswerOption === person.idAnswerOption)?.dsAnswerOption || ""
  }

  if (Array.isArray(value)) {
    value = value.map(item => item.dsAnswerOption).join(", ")
  }

  return (
    <Content>
      <Title>{field}</Title>
      <Text>{value}</Text>
    </Content>
  )
}

export { EnquiryCardContainer };
export default EnquiryCard;
